var app = angular.module("leonardo");

var DeclineInvitationDialog = function($scope) {
  $scope.submit = function() {
    $scope.ngDialogData.invitation.decline().then(function(){
      $scope.confirm();
    });
  };
};

app.controller('DeclineInvitationDialog', ['$scope', DeclineInvitationDialog]);
